import React from 'react';
import { Typography } from '@mui/material';
import ActionDialog from 'common/components/ActionDialog';
import { OrderPayment } from 'common/types';
import { hasUnreleasedMoneyDeposit } from 'common/modules/atoms/deposit';
import { useTranslation } from 'services/localization/useTranslation';
import { DepositPricing } from 'common/modules/atoms/pricing';

interface Props {
	onConfirm: () => void;
	onCancel: () => void;
	deposit: DepositPricing;
	payment: OrderPayment;
}

const DepositReleaseDialog = ({ onConfirm, onCancel, deposit, payment }: Props) => {
	const moneyDeposit = hasUnreleasedMoneyDeposit(deposit, payment);
	const { t } = useTranslation();
	return (
		<ActionDialog
			title={
				moneyDeposit
					? t(
							'depositReleaseDialog.titleMoney',
							'Rental has unreleased deposit that will be released',
					  )
					: t('depositReleaseDialog.titleOther', 'Remember to return the deposit')
			}
			btnActions={{
				primary: {
					text: t('common:actions.confirm'),
					onClick: onConfirm,
				},
				secondary: {
					text: t('common:actions.goBack', 'Go back'),
					onClick: onCancel,
				},
			}}
			onClose={onCancel}
		>
			{moneyDeposit ? (
				<>
					<Typography variant="body1" gutterBottom>
						{t(
							'depositReleaseDialog.infoMoney',
							'This rental still has a money deposit that must be released. If you confirm, the deposit will be automatically released, and cannot be charged anymore.',
						)}
					</Typography>
				</>
			) : (
				<Typography variant="body1" gutterBottom>
					{t(
						'depositReleaseDialog.infoOther',
						'This rental includes an item deposit - remember to return it to the customer!',
					)}
				</Typography>
			)}
		</ActionDialog>
	);
};

export default DepositReleaseDialog;
